export default "__VITE_ASSET__Lqwx4wxu__"